import { H1, H2, LI, P, UL } from '@expo/html-elements';
import React, { useState } from 'react';
import { ScrollView, StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import { CuratorHeader } from '../components/curator/CuratorHeader';
import { lgBreakpoint, smBreakpoint } from '../constants';
import { useDimensions } from '../context/DimensionsContext';
import { useThemeState } from '../context/ThemeContext';
import {
  GTAmerica,
  GTAmericaCompressed,
  mdbreakpoint,
  PanamaBold,
} from '../libs/constants';

interface Props { }

export const LargeCanvasScreen: React.FC<Props> = () => {
  document.title = 'Large Canvas Painting | Happy Medium';
  const { theme } = useThemeState();
  const { width, height } = useDimensions();
  const styles = StyleSheet.create({
    text: {
      color: theme.foregroundColor,
    },
    secondaryHeader: {
      fontFamily: GTAmericaCompressed,
      textTransform: 'uppercase',
      color: theme.foregroundColor,
      fontSize: width < smBreakpoint ? 20 : width < mdbreakpoint ? 24 : 28,
    },
    body: {
      fontFamily: GTAmerica,
      fontWeight: '300',
      fontSize: width < smBreakpoint ? 16 : width < mdbreakpoint ? 16 : 18,
      letterSpacing: 1.07,
    },
    infoText: {
      fontFamily: GTAmericaCompressed,
      fontSize: width < smBreakpoint ? 14 : width < mdbreakpoint ? 16 : 18,
      letterSpacing: 1.02,
    },
    header: {
      fontFamily: PanamaBold,
      color: theme.foregroundColor,
      textTransform: 'uppercase',
      alignSelf: 'center',
      fontSize: width < smBreakpoint ? 34 : width < mdbreakpoint ? 42 : 48,
      letterSpacing: 1.02,
      lineHeight: width < smBreakpoint ? 38 : width < mdbreakpoint ? 48 : 54,
      textAlign: 'center',
    },
    h2: {
      fontSize: width < smBreakpoint ? 28 : width < mdbreakpoint ? 34 : 40,
    },
    h3: {
      fontSize: width < smBreakpoint ? 22 : width < mdbreakpoint ? 24 : 28,
    },
    pushButton: {
      borderWidth: 1,
      borderColor: theme.foregroundColor,
      borderRadius: 5,
      // padding: 5,
      justifyContent: 'center',
      height: 100,
      // width: 222,
      marginHorizontal: width < mdbreakpoint ? 0 : 5,
      marginVertical: 5,
    },
    timeSlot: { width: width < lgBreakpoint ? 140 : 222 },
    item: { width: 222 },
  });

  type Size = 'Large' | 'Larger' | 'Largest';
  type Date = '7/29' | '7/30' | '8/19' | '8/21';
  type Frame = 'clear pine' | 'mahogany';
  type Location = 'Manhattan' | 'Brooklyn'
  const [selectedSize, setSelectedSize] = useState<Size>('Large');
  const [selectedDate, setSelectedDate] = useState<Date>('7/29');
  const [selectedFrame, setSelectedFrame] = useState<Frame>('clear pine');
  const [selectedLocation, setSelectedLocation] = useState<Location>('Manhattan');
  type PaymentLink = {
    size: Size;
    paymentLink: string;
    price: string;
    isAvailable?: boolean;
    date: Date
    frame: Frame
    location: Location
  };
  const paymentLinks: PaymentLink[] = [

    // {
    //   size: 'Large',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/14kdUw5CQ8iien659h',
    //   price: '$350',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Large',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/5kA3fSd5ibuu92M59i',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/bIY5o0aXa7ee5QAgS1',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/bIYcQs1mAfKKen6atE',
    //   price: '$500',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/5kA8Ac9T6eGGceY9pB',
    //   price: '$450',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/13',
    //   paymentLink: 'https://buy.stripe.com/cN2aIk2qEaqqgve8ly',
    //   price: '$600',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Large',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/cN2cQs0iw6aa1Ak6dr',
    //   price: '$350',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Large',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/6oE9Eg4yM7eedj245k',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/eVa7w8d5i422a6Q59p',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/eVacQs6GUgOO3Is59q',
    //   price: '$500',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/cN217K5CQ7ee5QAatL',
    //   price: '$450',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/14',
    //   paymentLink: 'https://buy.stripe.com/fZe6s49T6eGGbaU31k',
    //   price: '$600',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Large',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/5kA3fS2qE7eebaU8lF',
    //   price: '$350',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Large',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/dR6eYAc1e8ii5QAcBW',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/dR69Eg2qEbuu7YIeK5',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Larger',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/8wMeYA0iw1TU92M59w',
    //   price: '$500',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/dR6bMo7KYdCC92M59x',
    //   price: '$450',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Brooklyn'
    // },
    // {
    //   size: 'Largest',
    //   date: '8/15',
    //   paymentLink: 'https://buy.stripe.com/dR6bMo4yM1TUbaU8lK',
    //   price: '$600',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Brooklyn'
    // },




    {
      size: 'Large',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/7sY4gBageaqd0He58pd3i02',
      price: '$350',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Large',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/dRmbJ3bki69X1Li30hd3i03',
      price: '$400',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/28E7sNagefKx9dK44ld3i04',
      price: '$400',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/28EcN75ZY1THfC8cARd3i05',
      price: '$500',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/14AfZjgECbuh2PmasJd3i06',
      price: '$450',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '7/29',
      paymentLink: 'https://buy.stripe.com/fZu4gB8869m99dKeIZd3i07',
      price: '$600',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    // {
    //   size: 'Large',
    //   date: '5/14',
    //   paymentLink: '',
    //   price: '$350',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Large',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/cN2aIkc1edCC0whaXV',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Larger',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/dR617K3uI7ee2Ep8PO',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Larger',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/4gwdUwfdqcyyen7c21',
    //   price: '$500',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Largest',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/3cs6s4fdq1TUa6R7LM',
    //   price: '$450',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Largest',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/6oE8Ac2qEgOO6UFfef',
    //   price: '$600',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    {
      size: 'Large',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/00w14p7428i589G44ld3i08',
      price: '$350',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Large',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/cNi3cxcomaqd61y6ctd3i09',
      price: '$400',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/6oU9AVdsq2XLcpW0S9d3i0a',
      price: '$400',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/3cI14p2NMcylfC8asJd3i0b',
      price: '$500',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/8x25kFewu7e10HedEVd3i0c',
      price: '$450',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '7/30',
      paymentLink: 'https://buy.stripe.com/7sYaEZgECgOB9dK9oFd3i0d',
      price: '$600',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },

    {
      size: 'Large',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/14AcN7742fKx3TqfN3d3i0h',
      price: '$350',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Large',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/eVqaEZ5ZY55T9dKfN3d3i0i',
      price: '$400',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/3cIaEZgEC2XLcpWfN3d3i0j',
      price: '$400',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/aFacN79cabuhcpWasJd3i0k',
      price: '$500',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/5kQaEZgEC41PblSasJd3i0l',
      price: '$450',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '8/19',
      paymentLink: 'https://buy.stripe.com/bJedRb4VU0PD0HefN3d3i0m',
      price: '$600',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    // {
    //   size: 'Large',
    //   date: '5/14',
    //   paymentLink: '',
    //   price: '$350',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Large',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/cN2aIkc1edCC0whaXV',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Larger',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/dR617K3uI7ee2Ep8PO',
    //   price: '$400',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Larger',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/4gwdUwfdqcyyen7c21',
    //   price: '$500',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Largest',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/3cs6s4fdq1TUa6R7LM',
    //   price: '$450',
    //   isAvailable: true,
    //   frame: 'clear pine',
    //   location: 'Manhattan'
    // },
    // {
    //   size: 'Largest',
    //   date: '5/14',
    //   paymentLink: 'https://buy.stripe.com/6oE8Ac2qEgOO6UFfef',
    //   price: '$600',
    //   isAvailable: true,
    //   frame: 'mahogany',
    //   location: 'Manhattan'
    // },
    {
      size: 'Large',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/00w5kFbkifKxdu0bwNd3i0n',
      price: '$350',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Large',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/aFa14p5ZYdCpgGc6ctd3i0o',
      price: '$400',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/14A14p4VUcyl61y58pd3i0p',
      price: '$400',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Larger',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/4gMbJ374241P9dK58pd3i0q',
      price: '$500',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/7sYeVffAy7e10He7gxd3i0r',
      price: '$450',
      isAvailable: true,
      frame: 'clear pine',
      location: 'Manhattan'
    },
    {
      size: 'Largest',
      date: '8/21',
      paymentLink: 'https://buy.stripe.com/dRm00l7422XLahO44ld3i0s',
      price: '$600',
      isAvailable: true,
      frame: 'mahogany',
      location: 'Manhattan'
    },

  ]

  return (
    <>
      <ScrollView style={{ backgroundColor: theme.backgroundColor }}>
        <CuratorHeader />
        <View style={{ height: width < mdbreakpoint ? 20 : 40 }} />
        <View
          style={{
            justifyContent: 'center',
            width: 700,
            maxWidth: '90vw',
            alignSelf: 'center',
          }}
        >
          <H1 style={[styles.header, { marginBottom: 0 }]}>
            Large Canvas Painting
          </H1>
          <P
            style={[
              styles.text,
              styles.body,
              {
                alignSelf: 'center',
                marginTop: 0,
                letterSpacing: 1.2,
                marginBottom: 0,
                width: 280,
                textAlign: 'center',
              },
            ]}
          >
            July 29th and 30th{'\n'}
            August 19th and 21st
          </P>
          <View style={{ height: 10 }} />
          <Text
            style={[
              styles.text,
              styles.body,
              {
                alignSelf: 'center',
                textAlign: 'center',
                textTransform: 'uppercase',
                marginTop: 0,
                letterSpacing: 1,
                fontSize: 10,
              },
            ]}
          >
            Manhattan
          </Text>

          <P style={[styles.text, styles.body, { fontWeight: '700' }]}>
            Go big and go home.
          </P>
          <P style={[styles.text, styles.body]}>
            We all have that one spot in our home that needs a large piece of art - you know the one above the couch, bed, or entryway? Now's your chance to fill it with your own creativity.
          </P>
          <P style={[styles.text, styles.body]}>
            Join us from 6-9pm for an evening of large canvas painting at Happy Medium and leave with your new favorite piece.
          </P>
          <P style={[styles.text, styles.body]}>
            We will provide the paints, canvases, floating frames, inspiration and even sketch it for you if you want! You bring a buddy (or come solo) and get to work. Each ticket admits up to two people to paint one canvas. No experience necessary.
          </P>
          <P style={[styles.text, styles.body]}>
            Only at Happy Medium.
          </P>
          <P style={[styles.text, styles.body, { fontStyle: 'italic', fontSize: 14 }]}>
            **Please note, our tickets are non-refundable. You must notify us at reservations@happy-medium.co at least 72 hours before your time slot in order to be eligible to reschedule.** Local delivery available to the five boroughs only. Crate shipping available worldwide.
          </P>
          <P style={[styles.text, styles.body]}>
            Curbside delivery is available to all 5 boroughs (and only the 5 boroughs), and you can opt into delivery at the end of the event. For May, deliveries will be made on May 23rd - this is our only delivery date, so if you're unable to make it work, opt for pick up. Delivery prices are per painting, regardless of if they're going to the same address. **Please note, Largest size canvases will not fit in most cars, so we highly recommend opting for our delivery service unless you plan to rent a moving truck or hire movers.**
            <UL>
              <LI>Within a 2 mile radius of Happy Medium, delivery is $75</LI>
              <LI>Between a 2 and 6 mile radius of Happy Medium, delivery is $100</LI>
              <LI>Everywhere else in the 5 boroughs is $125</LI>
            </UL>
          </P>

          <H2 style={[styles.header, styles.h2, { marginBottom: 0 }]}>Select your date</H2>



          <View
            style={{
              flexDirection: width < 800 ? 'column' : 'row',
              justifyContent: 'space-around',
              width: '100%',
              alignContent: 'space-around',
              alignSelf: 'center',
            }}
          >

            <TouchableOpacity disabled={false} style={{ alignSelf: 'center', opacity: 1 }} onPress={() => setSelectedDate('7/29')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '7/29'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedDate === '7/29'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  July 29th (Manhattan)
                </P>
              </View>
            </TouchableOpacity>
            {/* <TouchableOpacity disabled={true} style={{ alignSelf: 'center', opacity: 0.3 }} onPress={() => setSelectedDate('5/14')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '5/14'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedDate === '5/14'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  May 14th (Manhattan) - SOLD OUT
                </P>
              </View>
            </TouchableOpacity> */}
            <TouchableOpacity disabled={false} style={{ alignSelf: 'center', opacity: 1 }} onPress={() => setSelectedDate('7/30')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '7/30'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      color:
                        selectedDate === '7/30'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                      textAlign: 'center'
                    },
                  ]}
                >
                  July 30th (Manhattan)
                </P>
              </View>
            </TouchableOpacity>

          </View>

          <View
            style={{
              flexDirection: width < 800 ? 'column' : 'row',
              justifyContent: 'space-around',
              width: '100%',
              alignContent: 'space-around',
              alignSelf: 'center',
            }}
          >

            <TouchableOpacity disabled={false} style={{ alignSelf: 'center', opacity: 1 }} onPress={() => setSelectedDate('8/19')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '8/19'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedDate === '8/19'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  August 19th (Manhattan)
                </P>
              </View>
            </TouchableOpacity>
            {/* <TouchableOpacity disabled={true} style={{ alignSelf: 'center', opacity: 0.3 }} onPress={() => setSelectedDate('5/14')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '5/14'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedDate === '5/14'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  May 14th (Manhattan) - SOLD OUT
                </P>
              </View>
            </TouchableOpacity> */}
            <TouchableOpacity disabled={false} style={{ alignSelf: 'center', opacity: 1 }} onPress={() => setSelectedDate('8/21')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedDate === '8/21'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      color:
                        selectedDate === '8/21'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                      textAlign: 'center'
                    },
                  ]}
                >
                  August 21st (Manhattan)
                </P>
              </View>
            </TouchableOpacity>

          </View>


          <H2 style={[styles.header, styles.h2, { marginBottom: 0 }]}>Select your size</H2>

          <View
            style={{
              flexDirection: width < 800 ? 'column' : 'row',
              justifyContent: 'space-around',
              width: '100%',
              alignContent: 'space-around',
              alignSelf: 'center',
            }}
          >

            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => setSelectedSize('Large')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedSize === 'Large'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedSize === 'Large'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  Large{'\n'}(36"x36")
                </P>
              </View>
            </TouchableOpacity>
            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => setSelectedSize('Larger')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedSize === 'Larger'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedSize === 'Larger'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  Larger{'\n'}(40"x58")
                </P>
              </View>
            </TouchableOpacity>
            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => setSelectedSize('Largest')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedSize === 'Largest'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      color:
                        selectedSize === 'Largest'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                      textAlign: 'center'
                    },
                  ]}
                >
                  Largest{'\n'}(48"x78")
                </P>
              </View>
            </TouchableOpacity>

          </View>

          <H2 style={[styles.header, styles.h2, { marginBottom: 0 }]}>Select your frame</H2>

          <View
            style={{
              flexDirection: width < 800 ? 'column' : 'row',
              justifyContent: 'center',
              width: '100%',
              alignContent: 'space-around',
              alignSelf: 'center',
            }}
          >

            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => setSelectedFrame('clear pine')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedFrame === 'clear pine'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedFrame === 'clear pine'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  clear pine{'\n'}(light)
                </P>
              </View>
            </TouchableOpacity>
            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={() => setSelectedFrame('mahogany')}>
              <View
                style={[styles.pushButton, styles.item, {
                  backgroundColor:
                    selectedFrame === 'mahogany'
                      ? theme.foregroundColor
                      : theme.backgroundColor,
                }]}
              >
                <P
                  style={[
                    styles.text,
                    styles.body,
                    {
                      textAlign: 'center',
                      color:
                        selectedFrame === 'mahogany'
                          ? theme.backgroundColor
                          : theme.foregroundColor,
                    },
                  ]}
                >
                  Mahogany{'\n'}(dark)
                </P>
              </View>
            </TouchableOpacity>

          </View>
        </View>
        <View style={{ height: 80 }} />
      </ScrollView>
      <TouchableOpacity disabled={false} style={{ opacity: 1 }} onPress={() => window.open(paymentLinks.find(l => l.size === selectedSize && l.frame === selectedFrame && l.date === selectedDate)?.paymentLink, '__blank')}>
        <View style={{ position: 'absolute', bottom: 0, right: width < mdbreakpoint ? undefined : 0, backgroundColor: theme.foregroundColor, borderRadius: 50, flexDirection: 'row', justifyContent: 'space-between', padding: 15, paddingHorizontal: 60, margin: 20, width: 320, alignSelf: 'center', borderWidth: 1, borderColor: theme.backgroundColor }}>
          {/* <Text style={[styles.text, styles.h3, { color: theme.backgroundColor, textTransform: 'uppercase', fontFamily: GTAmericaCompressed, letterSpacing: 1 }]}>Sold Out</Text> */}

          <Text style={[styles.text, styles.h3, { color: theme.backgroundColor, textTransform: 'uppercase', fontFamily: GTAmericaCompressed, letterSpacing: 1 }]}>Checkout</Text>
          <Text style={[styles.text, styles.h3, { color: theme.backgroundColor, textTransform: 'uppercase', fontFamily: GTAmericaCompressed, letterSpacing: 1 }]}>{paymentLinks.find(l => l.size === selectedSize && l.frame === selectedFrame)?.price}</Text>
        </View>
      </TouchableOpacity>
    </>
  );
};
